export default __webpack_public_path__ + "static/media/ivancik.ec9818b6.jpg";